import React from "react";
import { Icon, Menu } from "semantic-ui-react";
import { Link } from "react-router";

const SideBar = (props) => {
  return (
    <div id="sidebar-menu">
      <Menu
        className={props.active ? "nav-open" : "nav-closed"}
        icon="labeled"
        id="sidebar-menu-inner"
        vertical
      >
        <Menu.Item as={Link} to="/" name="home">
          <Icon name="home" />
          Home
        </Menu.Item>

        <Menu.Item
          as={Link}
          to={
            "/clients" +
            (props.filterMarket ? "?market=" + props.filterMarket : "")
          }
          name="clients"
        >
          <Icon name="briefcase" />
          Clients
        </Menu.Item>

        {props.userRole !== "ae" ? (
          <Menu.Item
            as={Link}
            to={
              "/rfps" +
              (props.filterMarket ? "?market=" + props.filterMarket : "")
            }
            name="rfps"
          >
            <Icon name="dollar" />
            RFPs
          </Menu.Item>
        ) : null}

        <Menu.Item
          as={Link}
          to={
            "/ios" + (props.filterMarket ? "?market=" + props.filterMarket : "")
          }
          name="ios"
        >
          <Icon name="rocket" />
          IOs
        </Menu.Item>

        {props.userRole === "admin" ||
        props.userRole === "dpm" ||
        props.userRole === "csm" ||
        props.userRole === "social" ? (
          <Menu.Item as={Link} to="/campaigns" name="campaigns">
            <Icon name="chart bar" />
            Campaigns
          </Menu.Item>
        ) : null}

        {props.userRole === "admin" ||
        props.userRole === "proposal_strategist" ? (
          <Menu.Item as={Link} to="/files" name="files">
            <Icon name="archive" />
            File Cabinet
          </Menu.Item>
        ) : null}

        {props.timeTracking === "1" ? (
          <Menu.Item as={Link} to="/time" name="time">
            <Icon name="clock" />
            Time
          </Menu.Item>
        ) : null}

        <Menu.Item as={Link} to="/search" name="search">
          <Icon name="search" />
          Search
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/ui/SideBar.js